module.exports = __webpack_public_path__ + "static/media/view-all-arrow.3f9aa1d6.svg";